import React from 'react';
import CustomBox from '../CommonComp/CustomBox/CustomBox';
import AllUserList from './AllGalexyPlanningList';
import AllDepartmentList from './AllGalexyPlanningList';
import AllGalexyPlanningList from './AllGalexyPlanningList';

function DepartmentTabBody({ activeTab }) {
  return (
    <CustomBox
      padding={0}
      sx={{
        minHeight: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {activeTab == 1 && <AllDepartmentList />}
    </CustomBox>
  );
}

export default DepartmentTabBody;
